import React, { Component } from "react";

export default class Services extends Component {
  render() {
    return (
      <>
        {/* ===== SERVICES SECTION (unchanged layout) ===== */}
        <section id="services" style={{ padding: "60px 0" }}>
          {/* Mobile stacking helper */}
          <style>{`
            @media (max-width: 991px) {
              #services .fa-flex-row { display: block !important; }
              #services .fa-col-left,
              #services .fa-col-right {
                flex: 0 0 100% !important;
                max-width: 100% !important;
              }
            }
          `}</style>

          <div className="container">
            <div
              className="row fa-flex-row"
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
              }}
            >
              {/* LEFT: Owner photo + description */}
              <div
                className="col-md-5 col-sm-12 fa-col-left"
                style={{
                  flex: "0 0 41.6667%",
                  maxWidth: "41.6667%",
                  marginBottom: 30,
                  textAlign: "left",
                }}
              >
                <img
                  src={process.env.PUBLIC_URL + "/MeetOwner.png"}
                  alt="Founder of FA Solutions"
                  loading="lazy"
                  style={{
                    width: "100%",
                    maxWidth: 520,
                    height: "auto",
                    display: "block",
                    borderRadius: 10,
                    boxShadow: "0 10px 24px rgba(0,0,0,.12)",
                    marginBottom: 18,
                  }}
                  onError={(e) =>
                    console.log("Image not found at:", e.currentTarget.src)
                  }
                />
                <h3 style={{ fontWeight: 700, marginBottom: 8 }}>Meet the Founder</h3>

                {/* ✅ Updated copy — no CRA wording */}
                <p style={{ fontSize: 16, lineHeight: 1.6, color: "#444" }}>
                 As the owner of <strong>FA Tax and Accounting Solutions</strong>, I work directly with small business owners, contractors, and incorporated professionals to handle <strong>corporate T2 tax filing</strong>, <strong> GST/HST filing &amp; reconciliation</strong>, and <strong>bookkeeping</strong> quickly and accurately
                  so you can focus on running your business.{" "}

                  <strong>Call us now for a free consultation and same-day estimate.</strong>
                </p>

                {/* ✅ Updated bullet points — no CRA */}
                <ul style={{ paddingLeft: 18, marginTop: 12, color: "#333" }}>
                  <li>✔️ T2 Corporate Tax Filing</li>
                  <li>✔️ GST/HST Filing &amp; Reconciliation</li>
                  <li>✔️ Bookkeeping &amp; Prior-Year Adjustments</li>
                </ul>

                <a
                  href="tel:+16138176185"
                  className="btn btn-primary"
                  style={{ marginTop: 12, background: "#17569b", borderColor: "#17569b" }}
                >
                  📞 Call Now for Tax Help
                </a>
              </div>

              {/* RIGHT: Services list */}
              <div
                className="col-md-7 col-sm-12 text-center fa-col-right"
                style={{
                  flex: "0 0 58.3333%",
                  maxWidth: "58.3333%",
                }}
              >
                <div className="section-title" style={{ marginBottom: 20 }}>
                  <h2>Our Services</h2>
                  <p>Here are some of our professional services:</p>
                </div>

                <div className="row">
                  {this.props.data
                    ? this.props.data.map((d, i) => (
                        <div
                          key={`${d.name}-${i}`}
                          className="col-md-6 col-sm-6"
                          style={{ marginBottom: 24 }}
                        >
                          <i className={d.icon}></i>
                          <div className="service-desc">
                            <h3>{d.name}</h3>
                            <p>{d.text}</p>
                          </div>
                        </div>
                      ))
                    : "loading"}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ===== WHY CHOOSE US (new) ===== */}
        <section
          id="why"
          style={{
            padding: "80px 20px",
            background: "linear-gradient(to right, #f9fbff, #eef5ff)",
color: "#17569b",


            textAlign: "center",
          }}
        >

<style>{`
  #why .why-card {
    transition: all 0.25s ease;
  }
  #why .why-card:hover {
    transform: translateY(-6px);
    box-shadow: 0 8px 20px rgba(23,86,155,0.25);
  }
`}</style>

          <div className="container">
           <h2
  style={{
    fontSize: "30px",
    fontWeight: 800,
    color: "#17569b",
    marginBottom: "40px",
    letterSpacing: "0.5px",
    textTransform: "uppercase",
  }}
>
  Why Choose FA Tax and Accounting Solutions?
</h2>


            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
                gap: "28px",
                maxWidth: "1000px",
                margin: "0 auto",
                textAlign: "left",
              }}
            >
              {/* Card 1 */}
              <div
className="why-card"
                style={{
                  background: "white",
                  borderRadius: "10px",
                  padding: "24px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                }}
              >
                <h4 style={{ color: "#17569b", fontWeight: 700 }}>✔ Flat-Fee Pricing</h4>
                <p style={{ opacity: 0.9 }}>
                  No hourly surprises. All corporate tax and bookkeeping packages are clear, upfront, and flat-rate.
                </p>
              </div>

              {/* Card 2 */}
              <div
className="why-card"
                style={{
                  background: "white",
                  borderRadius: "10px",
                  padding: "24px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                }}
              >
                <h4 style={{ color: "#17569b", fontWeight: 700 }}>✔ Same-Day Response</h4>
                <p style={{ opacity: 0.9 }}>
                  We reply within 24 hours! Often the same day because your time and peace of mind matter.
                </p>
              </div>

              {/* Card 3 */}
              <div
className="why-card"
                style={{
                  background: "white",
                  borderRadius: "10px",
                  padding: "24px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                }}
              >
                <h4 style={{ color: "#17569b", fontWeight: 700 }}>✔ Expert Corporate Focus</h4>
                <p style={{ opacity: 0.9 }}>
                  We specialize in T2 filings, GST/HST returns, and small-business bookkeeping for incorporated companies.
                </p>
              </div>

              {/* Card 4 */}
              <div
className="why-card"
                style={{
                  background: "white",
                  borderRadius: "10px",
                  padding: "24px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                }}
              >
                <h4 style={{ color: "#17569b", fontWeight: 700 }}>✔ Remote &amp; Local Service</h4>
                <p style={{ opacity: 0.9 }}>
                  Whether you’re in Ottawa, Toronto, Montreal, or anywhere in Canada. We work securely and seamlessly online.
                </p>
              </div>
{/* Card 5 */}
<div
className="why-card"
  style={{
    background: "white",
    borderRadius: "10px",
    padding: "24px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
  }}
>
  <h4 style={{ color: "#17569b", fontWeight: 700 }}>✔ Secure Online Process</h4>
  <p style={{ opacity: 0.9 }}>
    Encrypted documents so your information stays safe and confidential.
  </p>
</div>

{/* Card 6 */}
<div
className="why-card"
  style={{
    background: "white",
    borderRadius: "10px",
    padding: "24px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
  }}
>
  <h4 style={{ color: "#17569b", fontWeight: 700 }}>✔ On-Time Filing Guarantee</h4>
  <p style={{ opacity: 0.9 }}>
    Clear timelines from day one. We prepare and file on schedule so you avoid
    penalties and last-minute stress.
  </p>
</div>

            </div>
          </div>
        </section>
      </>
    );
  }
}
